define([
    'uiComponent',
    'bootstrap/scrollspy',
    'bootstrap/offcanvas'
], (Component, ScrollSpy) => {
    "use strict";

    return Component.extend({
        initialize: function (config, target) {
            const element = document.querySelector('#factory-tour .chapters');
            let scrollSpy = null;
            target.setAttribute('data-bs-scroll', false);
            scrollSpy = new ScrollSpy(element, {
                target: target,
                threshold: [0.01] // todo: this works, but should it be finetuned?
            });
            target.addEventListener('shown.bs.offcanvas', () => {
                return scrollSpy.refresh();
            });
        }
    });
});
